import axios from 'axios'
import {
  MessageBox
} from 'element-ui'
import {
  getCookie,
  removeCookie
} from '../util/utils'

export const baseURL = '/api'
const Axios = axios.create({
  baseURL: baseURL,
  timeout: 1000000,
  responseType: 'json',
  withCredentials: true, // 是否允许带cookie
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    // 在发送请求之前
    if (getCookie('pd_token')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers['pd_token'] = getCookie('pd_token')
    }
    if (
      config.method === 'post'
    ) {
      // config.headers = {
      //   'Content-Type': 'application/x-www-form-urlencoded'
      // }
      // config.transformRequest = [function (data) {
      //   let ret = ''
      //   for (let it in data) {
      //     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      //   }
      //   return ret
      // }]
    }
    return config
  },
  error => {
    return Promise.reject(error.data)
  }
)

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    if (res.data.code === 401 || res.data.code === '401') {
      MessageBox.alert(res.data.msg || res.data.result.msg || 'Token失效，请重新登录', '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: action => {
          window.location.href = '/login'
          removeCookie('pd_token')
        }
      })
    } else if (res.data.code === 100 || res.data.code === '100') {
      return res.data
    } else {
      // Message.info(res.data.msg || res.data.actionSheet.content)
      // MessageBox.alert(res.data.msg, '提示', {
      //   type: 'info',
      //   confirmButtonText: '确定'
      // })
      return res.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)
// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, '$http', {
      value: Axios
    })
  }
}



// WEBPACK FOOTER //
// ./src/server/index.js